import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SeFeEmptyStateModule } from "se-fe-empty-state";
import { SeFeIconModule } from "se-fe-icon";

@Component({
  selector: 'se-public-api-app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.css'],
  imports: [SeFeEmptyStateModule, SeFeIconModule, TranslatePipe],
})
export class AppErrorComponent {
  public year = new Date().getFullYear();
  public readonly errorKey: string;

  constructor() {
    this.errorKey = inject(ActivatedRoute).snapshot.params['errorKey']?.replace(/-/g, '_');
  }

  public get title(): string {
    return `APP_ERROR.${this.errorKey}.title`;
  }

  public get errorMessage(): string {
    return `APP_ERROR.${this.errorKey}.message`;
  }
}
